import { put, select } from 'redux-saga/effects';

import { tracker } from '../../utils/core';
import { achievementsSelectors } from '../achievements';
import { resourceSagaUtils, resourceStoreTypes } from '../core';
import { featureFlagsSelectors } from '../feature-flags';

import * as actions from './milestonesActions';
import { isAchievementCompletedOrStarted } from './milestonesSelectors';
import { mkMilestone } from './milestonesTypes';

const mkResourceConfigMilestones = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'milestones',
    resourceBaseUrl: '/gamification/milestones',
    // getLastSyncDate, // TODO: QCS need to fix it
    transformResponseToResources: (response) => response?.data?.resources?.map((data) => mkMilestone(data)),
    ...props,
  });

const { callFirst, callLast } = resourceSagaUtils.createGreedDebounce('milestonesDumpUpdater');
export function* milestonesDumpUpdater(resources) {
  const bumpBadges = yield select(featureFlagsSelectors.getFeatureFlag, 'bumpBadges');
  if (bumpBadges) {
    yield callFirst(milestonesDumpUpdaterFull, resources);
    yield callLast(milestonesNudgeUpdater);
  }
}

function* milestonesDumpUpdaterFull(resources) {
  try {
    const milestoneData = resources.map((data) => mkMilestone(data));
    yield put(actions.updateMilestone(milestoneData, { context: 'BUMP_CHANGE_DUMP' }));
    const achievement = yield select(achievementsSelectors.getAchievementById, { id: milestoneData[0]?.achievementId });
    tracker.track(tracker.events.milestonesEarned, {
      achievementName: achievement?.name,
      count: milestoneData[0]?.currentCount,
      milestoneName: milestoneData[0]?.name,
    });
    const completedObj = yield select(isAchievementCompletedOrStarted, {
      achievementId: milestoneData[0]?.achievementId,
    });
    if (completedObj?.isCompleted) {
      tracker.track(tracker.events.achievementComplete, { achievementName: achievement?.name });
    }
    if (completedObj?.justStarted) {
      tracker.track(tracker.events.achievementStart, { achievementName: achievement?.name });
    }
    yield put(actions.milestoneReceivedNotification({ milestoneData }));
  } catch (error) {
    assert(false, error);
  }
}

export function* milestonesNudgeUpdater() {
  const bumpBadges = yield select(featureFlagsSelectors.getFeatureFlag, 'bumpBadges');
  if (bumpBadges) {
    yield put(actions.getMilestones(undefined, { context: 'BUMP_CHANGE_NUDGE' }));
  }
}

export function* getMilestonesActionWatcher() {
  const config = mkResourceConfigMilestones({
    successAction: actions.getMilestonesSuccess,
    failureAction: actions.getMilestonesFailure,
  });
  yield resourceSagaUtils.takeAndDebounce(actions.getMilestones, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getMilestonesActionWatcher];
